document.addEventListener('DOMContentLoaded', () => {
  const dropHintModal = document.querySelector<HTMLFormElement>('#drop-a-hint-modal');

  if (!dropHintModal) {
    // console.debug('Drop-a-Hint form not found');
    return;
  }

  const recipientNameInput = dropHintModal.querySelector<HTMLInputElement>('input[name="recipientName"]');
  const yourNameInput = dropHintModal.querySelector<HTMLInputElement>('input[name="yourName"]');
  const recipientNameBlank = dropHintModal.querySelector<HTMLSpanElement>('.js-recipient-name');
  const yourNameBlank = dropHintModal.querySelector<HTMLSpanElement>('.js-your-name');
  const productImage = dropHintModal.querySelector<HTMLImageElement>('.drop-a-hint__img');

  if (!recipientNameInput || !yourNameInput || !recipientNameBlank || !yourNameBlank || !productImage) {
    console.error('Drop-a-Hint form elements not found');
    return;
  }

  // Add event listeners

  // Keep the recipient name in sync with the input field
  recipientNameInput.addEventListener('input', () => {
    recipientNameBlank.textContent = recipientNameInput.value;
  });

  // Keep the your name in sync with the input field
  yourNameInput.addEventListener('input', () => {
    yourNameBlank.textContent = yourNameInput.value;
  });

  // Listen to the custom event to update the sticky buy image
  // This is emitted in gallery.ts, when the flickity gallery changes slide
  document.addEventListener('product:image-change', (event: CustomEvent) => {
    const { image } = event.detail;
    console.debug('Product image has changed', image);
    // Setting data-src as well so it doesn't replace with placeholder on initial load
    productImage.setAttribute('data-src', image);
    productImage.setAttribute('src', image);
  });
});
